(function ($) {
  videoCarouselInternetVideoV1 = {
    formatter: $('.video-carousel-internet-video-v1')
  };

  Drupal.behaviors.videoCarouselInternetVideoV1 = {
    get: function (key) {
      return videoCarouselInternetVideoV1[key];
    },

    set: function (key, val) {
      videoCarouselInternetVideoV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var player = self.get('formatter').find('.flex-video');
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        if ($('body').hasClass('device-mobile')) {
        // Shrink the video title to a min number of characters
          var videoTitle = thisFormatter.find('.video-main .video-title');

          if (videoTitle.text().length > 50) { // raised from 13
            videoTitle.each(function () {
              videoTitle = $(this).text($(this).text().substr(0, 46) + '...');
            });
          }

          // Shrink the video description to a min number of characters
          var videoDesc = thisFormatter.find('.video-main .video-description');

          if (videoDesc.text().length > 52) {
            videoDesc.each(function () {
              var more = '<div class="more"><a href="javascript:void(0)">More</a></div>';

              $(this).append(more);

              // Expand the video description box
              $('.more').on('click', function(e) {
                e.stopPropagation();
                $('div.vid-desc').css({ 'height': 'auto' });
                $(this).hide();
              });

              // Contract the video description box
              $(document).on('click', function() {
                $('div.vid-desc').css({ 'height': '30px' });
                $('.more').show();
              });
            });
          }
        }
      });
    }
  };
})(jQuery);
